import React from 'react'
import { RouteLine } from 'common/Map/RouteLine'

// DEPRECATED - compatibility layer for old Maplet stuff
export class Route extends React.PureComponent {
  static defaultProps = {
    showPOIs: true
  }
  render () {
    const { route, color, lineOpts, showMarkers, showDistanceMarkers } = this.props
    return (
      <RouteLine {...lineOpts} route={route} color={color} showStartMarker={showMarkers} showEndMarker={showMarkers} showDistanceMarkers={showDistanceMarkers} />
    )
  }
}
